<template>
  <div class="drawer-wrap">
    <div @click="openDialog">
      <slot></slot>
    </div>
    <el-dialog
      title="学员回收"
      @close="closeView"
      :visible.sync="viewbtns"
      width="40%"
      :modal-append-to-body="false"
    >
      <div class="pushBody">
        <div class="student-info">
          学员信息:
          <span>{{ studentInfo.name }} | {{ studentInfo.mobile }}</span>
        </div>
        <div class="pushTips">
          回收后学员会移动至回收列表，基本信息与跟进记录同步保留。
        </div>
        <el-form
          size="mini"
          :inline="true"
          :rules="rules"
          :model="form"
          ref="suspension"
        >
          <div class="suspensionBox">
            <el-form-item
              label-width="80px"
              label="回收分类:"
              prop="recycle_category_id"
              class="recovery"
            >
              <el-select
                v-model.number="form.recycle_category_id"
                clearable
                placeholder="请选择"
              >
                <el-option label="多次未接" :value="1"></el-option>
                <el-option label="距离超过3公里" :value="2"></el-option>
                <el-option label="没意向" :value="3"></el-option>
                <el-option label="年龄不到3岁" :value="4"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="回收原因:"
              label-width="80px"
              prop="remark"
              class="recovery"
            >
              <el-input
                class="textarea"
                type="textarea"
                placeholder="请输入原因"
                v-model="form.remark"
                maxlength="250"
                show-word-limit
                :rows="5"
              >
              </el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="mwow-button-filled mini" @click="closeView">取消</div>
        <div class="mwow-button-filled mini success" @click="postClick">
          确定
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { recycleStudentApi } from "@/api/studentManage";
import { waitingStudentClaimConfirm } from "@/utils/student-details";

export default {
  // @Prop() studentInfo!: any;
  props: ["studentInfo"],
  data() {
    return {
      form: {
        remark: "",
      },
      viewbtns: false,
      rules: {
        recycle_category_id: [
          { required: true, message: "请选择回收分类", trigger: "change" },
        ],
      },
    };
  },

  methods: {
    closeView() {
      this.viewbtns = false;
    },
    openDialog() {
      if (
        !this.studentInfo.follow_staff_id &&
        this.$route.query.from === "waiting_student"
      ) {
        waitingStudentClaimConfirm({
          studentName: this.studentInfo.name,
          studentID: Number(this.studentInfo.student_id),
          claimSuccessCallback: () => {
            this.viewbtns = true;
            this.form = {
              remark: "",
            };
          },
        });
      } else {
        this.viewbtns = true;
        this.form = {
          remark: "",
        };
      }
    },
    postClick() {
      const _t = this;
      const data = {
        student_id: _t.studentInfo.student_id,
        recycle_category_id: _t.form.recycle_category_id,
        recycle_remark: _t.form.remark,
      };
      _t.$refs["suspension"].validate((res) => {
        if (res) {
          recycleStudentApi(data).then((data) => {
            if (data.error_code === 0) {
              this.$message({
                type: "success",
                message: `学员已回收`,
              });
              this.$emit("recovery");
              this.form.remark = "";
            } else if (data.error_code === 21009009) {
              this.$message({
                type: "error",
                message: data.message,
              });
            }
            this.viewbtns = false;
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.drawer-wrap {
  display: inline-block;
  /deep/ .el-dialog {
    min-width: 500px !important;
  }
  .pushTips {
    color: #ffb940;
    padding-left: 10px;
  }
  .suspensionBox {
    .textarea {
      width: 300px;
    }
  }
  .el-form-item__content {
    width: 400px !important;
  }
  .recovery {
    display: flex;
  }
  .student-info {
    height: 30px;
    padding-left: 10px;
  }
  /deep/ .el-select {
    width: 300px;
  }
}
</style>
